import flru from 'flru';
var cache = flru(3);
/**
 * A decorator to return new function with LRU cache.
 */
export function lru(fn) {
  var keyFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return "".concat(arguments.length <= 0 ? undefined : arguments[0]);
  };
  var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
  var cache = flru(maxSize);
  return function () {
    var key = keyFn.apply(void 0, arguments);
    var v = cache.get(key);
    if (cache.has(key)) return cache.get(key);
    v = fn.apply(void 0, arguments);
    cache.set(key, v);
    return v;
  };
}